<template>
  <div class="mx-md-12 px-sm-12 text-center">
    <p class="display-1 primary--text text-center">Langzeitpflege</p>

    <p align="justify">
      Wenn Sie sich dazu entscheiden, oder es für Ihre Familiensituation notwendig wird 
      in ein Alten- und Pflegeheim zu übersiedeln, sind im Vorfeld verschiedene Voraussetzungen und Anträge erforderlich.
      Für eine Aufnahme ist Voraussetzung die Pflegestufe 4.
      Bei einer Pflegestufe zwischen 0-3 ist die Beurteilung durch eine/n Koordinator/in
      durch den Sozialhilfeverband Vöcklabruck notwendig.
      Für aktuelle detaillierte Informationen wenden Sie sich bitte an die Sozialberatungsstelle
      in Vöcklamarkt (07682/39527, 
      <a href="mailto:sbs.voecklamarkt@sozialberatung-vb.at">sbs.voecklamarkt@sozialberatung-vb.at</a>) 
      oder rufen Sie am besten vormittags bei uns unter 07683/8553 an.
    </p>
    
    <p>
      Sollten Sie bereits eine Zusage zu einem Heimplatz bekommen haben, so lesen Sie bitte unseren Leitfaden zum Heimeinzug. 
      Das Dokument steht als PDF zum Download zur Verfügung:
      
      <a v-bind:href="leitfaden" target="_blank" download="Leitfaden_Heimeinzug.pdf">Leitfaden Heimeinzug</a>
    </p>

    <img
    class="hidden-sm-and-down"
    width="50%"
    :src="require('@/assets/Angebote/Langzeitpflege/Zimmer_Hartmann.jpg')"
    />

    <img
    class="hidden-md-and-up"
    width="100%"
    :src="require('@/assets/Angebote/Langzeitpflege/Zimmer_Hartmann.jpg')"
    />
  </div>
</template>

<script>
  export default {
    name: 'langzeitpflege',


  }
</script>
